<template>
  <div class="monitor-size">
    <v-tooltip bottom content-class="monitor-size-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon aria-label="Размеры окна и экрана" v-bind="attrs" v-on="on" @click="monitorSize = !monitorSize">
          <v-icon>{{ monitorSize ? 'mdi-monitor-eye' : 'mdi-monitor' }}</v-icon>
        </v-btn>
      </template>
      <div class="monitor-size__details">
        <small>Размеры экрана</small>
        <span>Окно (viewport)</span><strong>{{ window_width }}×{{ window_height }}</strong>
        <span>Экран (screen)</span><strong>{{ screenWidth }}×{{ screenHeight }}</strong>
        <span>Плотность (DPR)</span><strong>{{ dpr }}×</strong>
        <span>Режим интерфейса</span><strong>{{ mode }}</strong>
      </div>
    </v-tooltip>
    <span v-if="monitorSize" class="monitor-size__inline">{{ window_width }}×{{ window_height }}</span>
  </div>
</template>
<script>
export default {
  name: 'MonitorSize',
  data: () => ({ monitorSize: false, screenWidth: window.screen.width, screenHeight: window.screen.height, dpr: window.devicePixelRatio || 1 }),
  computed: {
    window_height() { return this.$store.state.window_height },
    window_width() { return this.$store.state.window_width },
    mode() { return this.$vuetify.breakpoint.smAndDown ? 'Мобильный' : this.$vuetify.breakpoint.md ? 'Планшет' : 'Десктоп' }
  },
  mounted() { window.addEventListener('resize', this.updateScreen); window.addEventListener('orientationchange', this.updateScreen) },
  beforeDestroy() { window.removeEventListener('resize', this.updateScreen); window.removeEventListener('orientationchange', this.updateScreen) },
  methods: {
    updateScreen() { this.screenWidth = window.screen.width; this.screenHeight = window.screen.height; this.dpr = Math.round((window.devicePixelRatio || 1) * 100) / 100 }
  }
}
</script>
<style>
.monitor-size { display: inline-flex; align-items: center; }
.monitor-size__inline { font-size: 12px; white-space: nowrap; font-variant-numeric: tabular-nums; }
.monitor-size-tooltip { background: var(--sts-surface) !important; color: var(--sts-text) !important; border: 1px solid var(--sts-line); box-shadow: 0 4px 16px rgba(0,0,0,.12); opacity: 1 !important; padding: 12px !important; }
.monitor-size__details { display: grid; grid-template-columns: auto auto; gap: 8px 18px; font-size: 12px; }
.monitor-size__details small { grid-column: 1 / -1; color: var(--sts-text-muted); }
.monitor-size__details strong { text-align: right; font-variant-numeric: tabular-nums; }
</style>
